module.exports = __webpack_public_path__ + "static/car-1f9cc3fd0b6d331a1329a1b9420f1f9a.svg";